__turbopack_context__.v({
  "accessory": "cart-module__-RJi4G__accessory",
  "cartTable": "cart-module__-RJi4G__cartTable",
  "checkout": "cart-module__-RJi4G__checkout",
  "draftActions": "cart-module__-RJi4G__draftActions",
  "draftMeta": "cart-module__-RJi4G__draftMeta",
  "draftNotice": "cart-module__-RJi4G__draftNotice",
  "draftTable": "cart-module__-RJi4G__draftTable",
  "empty": "cart-module__-RJi4G__empty",
  "linkButton": "cart-module__-RJi4G__linkButton",
  "message": "cart-module__-RJi4G__message",
  "muted": "cart-module__-RJi4G__muted",
  "operationCell": "cart-module__-RJi4G__operationCell",
  "page": "cart-module__-RJi4G__page",
  "priceCell": "cart-module__-RJi4G__priceCell",
  "productCell": "cart-module__-RJi4G__productCell",
  "productName": "cart-module__-RJi4G__productName",
  "quantityCell": "cart-module__-RJi4G__quantityCell",
  "quantityControl": "cart-module__-RJi4G__quantityControl",
  "renderDrafts": "cart-module__-RJi4G__renderDrafts",
  "selectCell": "cart-module__-RJi4G__selectCell",
  "stateBox": "cart-module__-RJi4G__stateBox",
  "summary": "cart-module__-RJi4G__summary",
  "summaryLeft": "cart-module__-RJi4G__summaryLeft",
  "tableScroll": "cart-module__-RJi4G__tableScroll",
  "title": "cart-module__-RJi4G__title",
  "topLine": "cart-module__-RJi4G__topLine",
  "total": "cart-module__-RJi4G__total",
  "wrap": "cart-module__-RJi4G__wrap",
});
